module.exports = __webpack_public_path__ + "img/facebook.ce66ea50.svg";